module.exports = __webpack_public_path__ + "img/logo-mini.8539ea86.svg";